import { render, staticRenderFns } from "./MyMenteeGoalTasks.vue?vue&type=template&id=dbecb56a"
import script from "./MyMenteeGoalTasks.vue?vue&type=script&lang=js"
export * from "./MyMenteeGoalTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports